<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('profile.editProfile') }} </div>
        </div>
        <div class="va-card__body">
          <form @submit.prevent="onsubmit()">
            <div class="row">
              <va-input
                v-model="name"
                type="text"
                :label="$t('profile.inputName')"
                :error="!!nameErrors.length"
                :error-messages="nameErrors"
                class="flex xs12 sm6 md6 lg6 xl6"
              />

              <va-input
                v-model="surname"
                type="text"
                :label="$t('profile.inputSurname')"
                :error="!!surnameErrors.length"
                :error-messages="surnameErrors"
                class="flex xs12 sm6 md6 lg6 xl6"
              />

              <va-input
                v-model="email"
                type="email"
                :label="$t('profile.inputEmail')"
                :error="!!emailErrors.length"
                :error-messages="emailErrors"
                class="flex xs12"
                disabled
              />

              <va-input
                v-model="mobile"
                type="text"
                :label="$t('profile.inputMobile')"
                :error="!!mobileErrors.length"
                :error-messages="mobileErrors"
                class="flex xs12"
              />
            </div>
            <div class="d-flex justify--center mt-3">
              <va-button type="submit" class="my-0">{{ $t('profile.btnUpdateProfile') }}</va-button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('profile.updatePassword') }} </div>
        </div>
        <div class="va-card__body">
          <form @submit.prevent="onpasssubmit()">
            <div class="row">
              <va-input
                v-model="password"
                type="password"
                :label="$t('profile.inputPassword')"
                :error="!!passwordErrors.length"
                :error-messages="passwordErrors"
                class="flex xs12 sm6 md6 lg6 xl6"
              />
              <va-input
                v-model="passwordAgain"
                type="password"
                :label="$t('profile.inputConfirmPassword')"
                :error="!!passwordAgainErrors.length"
                :error-messages="passwordAgainErrors"
                class="flex xs12 sm6 md6 lg6 xl6"
              />
            </div>
            <div class="d-flex justify--center mt-3">
              <va-button type="submit" class="my-0">{{ $t('profile.btnUpdatePassword') }}</va-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'Profile',
  data () {
    return {
      email: '',
      password: '',
      passwordAgain: '',
      name: '',
      surname: '',
      mobile: '',
      emailErrors: [],
      passwordErrors: [],
      passwordAgainErrors: [],
      nameErrors: [],
      surnameErrors: [],
      mobileErrors: [],
    }
  },
  methods: {
    onsubmit () {
      this.emailErrors = this.email ? [] : [this.$t('profile.requiredEmail')]
      this.nameErrors = this.name ? [] : [this.$t('profile.requiredName')]
      this.surnameErrors = this.surname ? [] : [this.$t('profile.requiredSurname')]
      if (this.mobile) {
        const phoneRegex = /^\+?[0-9]{6,14}$/
        if (!phoneRegex.test(this.mobile)) {
          this.mobileErrors.push(this.$t('profile.invalidPhone'))
        } else {
          this.mobileErrors = []
        }
      }
      if (!this.formProfileReady) {
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('userUpdate', {
        email: this.email,
        name: this.name,
        surname: this.surname,
        mobile: this.mobile,
      }).then(() => this.$store.commit('setLoading', false)).catch(err => this.errorHandler(err.response))
    },
    onpasssubmit () {
      this.passwordErrors = this.password ? [] : [this.$t('profile.requiredPassword')]
      this.passwordAgainErrors = this.passwordAgain ? [] : [this.$t('profile.requiredConfirmPassword')]
      if (!this.formPasswordReady) {
        return
      }
      if (this.password !== this.passwordAgain) {
        this.passwordErrors = [this.$t('profile.passwordError')]
        this.passwordAgainErrors = [this.$t('profile.passwordAgainError')]
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('passwordUpdate', {
        password: this.password,
      }).then(() => this.$store.commit('setLoading', false)).catch(err => this.errorHandler(err.response))
      // this.$router.push({ name: 'dashboard' })
    },
    async initUser () {
      const user = this.$store.getters.user
      this.name = user.name
      this.surname = user.surname
      this.email = user.email
      if (user.meta && user.meta.mobile) {
        this.mobile = user.meta.mobile
      }
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
    formProfileReady () {
      return !(this.emailErrors.length || this.surnameErrors.length || this.nameErrors.length || this.mobileErrors.length)
    },
    formPasswordReady () {
      return !(this.passwordErrors.length || this.passwordAgainErrors.length)
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('userRequest').then(() => this.initUser())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped>

</style>
